export default __webpack_public_path__ + "static/media/mainpage-logo.6920ddcb.svg";